import React, { useState } from "react";
import { Grid, Box } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { AddEdition } from "components/AddEdition";
import { ConfigEtapa } from "components/ConfigEtapa";
import { ConfigInformacoes } from "components/ConfigInformacoes";

export const Configurations = () => {
  const [current, setCurrent] = useState<number>(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    if (newValue === 0) {
      setCurrent(0);
    } else if (newValue === 1) {
      setCurrent(1);
    } else if (newValue === 2) {
      setCurrent(2);
    }
  };

  let activeTabIndex = 0;
  if (current === 1) {
    activeTabIndex = 1;
  } else if (current === 2) {
    activeTabIndex = 2;
  }

  return (
    <Grid container gap={4}>
      <Grid item xs={12}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={activeTabIndex}
            onChange={handleChange}
            aria-label="navigation tabs"
          >
            <Tab label="Edições" />
            <Tab label="Etapas" />
            <Tab label="Informações" />
          </Tabs>
        </Box>
      </Grid>

      {current === 0 && (
        <Grid item xs={12}>
          <AddEdition />
        </Grid>
      )}
      {current === 1 && (
        <Grid item xs={12}>
          <ConfigEtapa />
        </Grid>
      )}
      {current === 2 && (
        <Grid item xs={12}>
          <ConfigInformacoes />
        </Grid>
      )}
    </Grid>
  );
};
